import axios, { CancelToken } from "axios";

import config from "config/global";
import { MediaObject } from "shared-types";

class MediaService {
  private url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async get(
    id?: string,
    cancellationToken?: CancelToken
  ): Promise<MediaObject> {
    const { data } = await axios(`${this.url}/media/${id}`, {
      cancelToken: cancellationToken,
    });

    return data.value;
  }
}

export const titaniumApiUrl = config.titaniumApiUrl;

export default new MediaService({
  url: titaniumApiUrl,
});
